if (!customElements.get("community-products-swiper")) {
  customElements.define(
    "community-products-swiper",
    class extends HTMLElement {
      constructor() {
        super();
        this.swiperEl = this.querySelector(".swiper");
        this.prevEl = this.querySelector(".slideshow-swiper__navigation .swiper-btn-prev");
        this.nextEl = this.querySelector(".slideshow-swiper__navigation .swiper-btn-next");
        this.paginationEl = this.querySelector(".swiper-pagination");
      }

      connectedCallback() {
        this.swiper = new Swiper(this.swiperEl, {
            spaceBetween: 100,
            navigation: {
              nextEl: this.nextEl,
              prevEl: this.prevEl,
            },
            pagination: {
              el: this.paginationEl,
              clickable: true,
            },
        });
      }
    }
  );
}
